import preloaderIcon from '@/assets/images/preloader.svg';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
  :host {
    display: flex;
    width: 24px;
    height: 24px;
  }
  
  img {
    width: 100%;
    height: 100%;
  }
`);
export class WPreloader extends HTMLElement {
    static tag = 'w-preloader';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <img src="${preloaderIcon}">
    `;
    }
}
customElements.define(WPreloader.tag, WPreloader);
